import { useEffect } from 'react';
import BasePage from './BasePage';
import { Box, Container, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function TermsOfService() {
  useEffect(() => {
    // Load the Termly script
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'TermsOfService.js'; // 'https://app.termly.io/embed-policy.min.js'; // 'TermsOfService.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      const script = document.getElementById('termly-jssdk');
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <BasePage
      title="CribCritic Terms of Service"
      description="Terms of Service for CribCritic AI"
      keywords="terms of service, legal agreement, terms and conditions"
      canonicalUrl="https://cribcritic.ai/terms-of-service"
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link 
            component={RouterLink} 
            to="/" 
            underline="hover" 
            color="inherit"
            zIndex={2001}
            sx={{ 
              '&:hover': { 
                color: 'primary.main',
                cursor: 'pointer' 
              },
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
              Home
            </Box>
          </Link>
          <Typography color="text.primary">Terms of Service</Typography>
        </Breadcrumbs>
        
        <Paper elevation={2} sx={{ p: { xs: 0, md: 0 }, borderRadius: 2 }}>          
          {/* Termly Terms of Service Embed using dangerouslySetInnerHTML */}
          <Box 
            sx={{ width: '100%' }}
            dangerouslySetInnerHTML={{
              __html: '<div name="termly-embed" data-id="baae0d79-f069-4462-8e2d-e2ffc55fb7f7"></div>'
            }}
          />
        </Paper>
      </Container>
    </BasePage>
  );
}

export default TermsOfService;